import { TerraMapLayerType } from "../generated/enums"
import { isArrayEmpty } from "../utils/array"
import { getTerraMapDynamicViewerOptions } from "./terramap"
import { IDataLayer, IDataLayerType, IDatalayerViewerFactory } from "./types"
import { TerramapDynamicLayerViewer } from "./viewers/terramap"

interface SetupVariantArg {

    readonly datalayer: IDataLayer
    readonly fieldId: number
    readonly fieldName?: string

    setViewer(viewer: IDatalayerViewerFactory): void

}

export function setupVariants(variants: SetupVariantArg[], type: IDataLayerType) {

    variants = variants.filter(v => v.datalayer.TerraMap == TerraMapLayerType.RawDynamicScale)

    if (isArrayEmpty(variants)) {
        return
    }

    const options = getTerraMapDynamicViewerOptions(type)

    for (const v of variants) {

        v.setViewer(TerramapDynamicLayerViewer.factory(type.TypeId, type.Name, {

            ...options,

            keyId: {
                id: `type-${type.TypeId}-field-${v.fieldId}`,
                name: [type.Name, v.fieldName].filter(t => !!t).join(" - "),
            }

        }))

    }

}
